export default __webpack_public_path__ + "static/media/hht2_ep14_timeline_q01_b.3fe2593a.png";